import React, { memo, useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { rem } from 'design-system/values';
import { HelpCallToAction } from 'design-system/HelpCallToAction';
import Links from 'utils/links';
import Amplitude from 'utils/amplitude';
const AnalyticsSectionFooter = () => {
    const openToolTip = useCallback(() => {
        Links.openKnownLink('amendAnalytics');
        Amplitude.logEvent('Categories.ClickInfo');
    }, []);
    return (<HelpCallToAction title="Need to amend your data?" subTitle="Learn how to do it" onPress={openToolTip} onDark style={styles.help}/>);
};
const styles = StyleSheet.create({
    help: {
        marginTop: rem(16),
    },
});
export default memo(AnalyticsSectionFooter);
